var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-tree',{ref:"xtree",attrs:{"data":_vm.editions,"options":_vm.options},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }